import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=30f65f67&scoped=true&"
import script from "./base-input.vue?vue&type=script&lang=js&"
export * from "./base-input.vue?vue&type=script&lang=js&"
import style0 from "./base-input.vue?vue&type=style&index=0&id=30f65f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f65f67",
  null
  
)

export default component.exports